class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.updatePickupAvailability()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateVariantQuantity()
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        ).value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().variants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const selector = `${this.dataset.section}-${this.currentVariant.featured_media.id}`
    const featuredMedia = document.querySelector(`[data-media-id="${selector}"]`)
    if (!featuredMedia) return
    const wrapper = featuredMedia.closest('.js-media-items')
    const section = wrapper.closest('section')
    wrapper.querySelectorAll('[data-media-id]').forEach(mediaItem => {
      if (mediaItem.getAttribute('data-media-id') == selector) {
        mediaItem.classList.add('hidden')
        section.querySelectorAll('.js-media-featured').forEach(element => {
          element.innerHTML = featuredMedia.innerHTML
        })
      } else {
        mediaItem.classList.remove('hidden')
      }
    })
    window.setTimeout(() => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }, 100)
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  updateVariantQuantity() {
    const variantQuantityEl = document.querySelector(
      '#current_variant_quantity'
    )

    if (variantQuantityEl) {
      const getVariantQty = (id) => {
        const variantDataQty = this.getVariantData().quantities
        const variant = variantDataQty.find((v) => v.id === id)
        return variant ? variant.quantity : null
      }

      this.newVariantQty = getVariantQty(this.currentVariant.id)

      const latestVariantQty = variantQuantityEl.dataset.inventory
      const inventoryCountThreshold =
        variantQuantityEl.dataset.inventoryCountThreshold

      let variantQtyText = variantQuantityEl.innerHTML

      variantQtyText = variantQtyText.replace(
        latestVariantQty,
        this.newVariantQty
      )

      variantQuantityEl.innerHTML = variantQtyText
      variantQuantityEl.dataset.inventory = this.newVariantQty
      variantQuantityEl.classList.toggle(
        'hidden',
        this.newVariantQty > inventoryCountThreshold || this.newVariantQty == 0
      )
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const source = html.getElementById(id)
        const destination = document.getElementById(id)
        const stickyDestination = document.querySelector(
          `[data-sticky-variant-price]`
        )

        if (source) {
          if (destination) destination.innerHTML = source.innerHTML
          if (stickyDestination) stickyDestination.innerHTML = source.innerHTML
        }

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    const stickyAddButton = document
      .getElementById(`sticky_atc`)
      ?.querySelector('[name="add"]')

    if (!addButton) return
    ;[addButton, stickyAddButton].forEach((button) => {
      if (button) {
        if (disable) {
          button.setAttribute('disabled', true)
          if (text) button.textContent = text
        } else {
          button.removeAttribute('disabled')
          button.textContent = window.variantStrings.addToCart
        }
      }
    })

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
